module.exports = __webpack_public_path__ + "img/82.b9f1ecd7.png";